/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = inBearbeitung (in Bearbeitung)
 * 
 * 401130001 = Abgesendet (Abgesendet)
 * 
 * 401130002 = Durchfuhrung (Durchführung)
 * 
 * 401130004 = Abgelehnt (Abgelehnt)
 * 
 * 401130005 = Zuruckgezogen (Zurückgezogen)
 * 
 * 401130006 = Abgelaufen (Abgelaufen)
 * 
 * 401130007 = Storniert (Storniert)
 * 
 * 401130008 = Beendet (Beendet)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceAnzeigestatusportal {
 inBearbeitung = 401130000,
 Abgesendet = 401130001,
 Durchfuhrung = 401130002,
 Abgelehnt = 401130004,
 Zuruckgezogen = 401130005,
 Abgelaufen = 401130006,
 Storniert = 401130007,
 Beendet = 401130008
}

marker([
    "Enum.GlobalEnumsAceAnzeigestatusportal.inBearbeitung",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Abgesendet",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Durchfuhrung",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Abgelehnt",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Zuruckgezogen",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Abgelaufen",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Storniert",
    "Enum.GlobalEnumsAceAnzeigestatusportal.Beendet"
]);

export namespace GlobalEnumsAceAnzeigestatusportal
{
    class DataSets
    {
        static GlobalEnumsAceAnzeigestatusportalDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("inBearbeitung", 401130000, "in Bearbeitung"),
            new EnumValue("Abgesendet", 401130001, "Abgesendet"),
            new EnumValue("Durchfuhrung", 401130002, "Durchführung"),
            new EnumValue("Abgelehnt", 401130004, "Abgelehnt"),
            new EnumValue("Zuruckgezogen", 401130005, "Zurückgezogen"),
            new EnumValue("Abgelaufen", 401130006, "Abgelaufen"),
            new EnumValue("Storniert", 401130007, "Storniert"),
            new EnumValue("Beendet", 401130008, "Beendet"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceAnzeigestatusportalDataSet;
    }
}
